var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .367188h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.2234.367188h-20.45153c-.979683 0-1.77187.773442-1.77187 1.729692v20.53592c0 .9563.792187 1.7344 1.77187 1.7344h20.45153c.9797 0 1.7766-.7781 1.7766-1.7297v-20.54062c0-.95625-.7969-1.729692-1.7766-1.729692zm-15.10309 20.451512h-3.5625v-11.4562h3.5625zm-1.78125-13.01714c-1.14375 0-2.06718-.92344-2.06718-2.0625s.92343-2.0625 2.06718-2.0625c1.13907 0 2.0625.92344 2.0625 2.0625 0 1.13438-.92343 2.0625-2.0625 2.0625zm15.11254 13.01714h-3.5579v-5.5687c0-1.3266-.0234-3.0375-1.8515-3.0375-1.8516 0-2.1328 1.4484-2.1328 2.9437v5.6625h-3.55315v-11.4562h3.41245v1.5656h.0469c.4735-.9 1.636-1.85154 3.3657-1.85154 3.6046 0 4.2703 2.37184 4.2703 5.45624z",
    fill: "#c2ccdd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6dabf41e428e0c5b2065b252f84c0511.svg";
export { ForwardRef as ReactComponent };